import { render, staticRenderFns } from "./MinusBtn.vue?vue&type=template&id=02b2dd4b&scoped=true&"
import script from "./MinusBtn.vue?vue&type=script&lang=js&"
export * from "./MinusBtn.vue?vue&type=script&lang=js&"
import style0 from "./MinusBtn.vue?vue&type=style&index=0&id=02b2dd4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b2dd4b",
  null
  
)

export default component.exports